import styled from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${Colors.GS200};

  ${mediaQueries.tablet} {
    flex-direction: row;
    align-items: center;
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  flex-wrap: wrap;
  min-height: 40px;
`

export const DomainName = styled.div`
  font-size: 20px;
  font-weight: 600;
`
